import { Component, OnInit } from '@angular/core';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gestion-productos',
  templateUrl: './gestion-productos.component.html',
  styleUrls: ['./gestion-productos.component.scss']
})
export class GestionProductosComponent implements OnInit {

  filterProducto = '';
  productosList: any;
  // productos
  nombre: string;
  categoria: string;
  descripcion: string;
  imagen: string;
  kiwi: string;
  limon: string;
  sinAroma: string;
  floral: string;
  citronela: string;
  lavanda: string;
  vinagre: string;
  frutosRojos: string;
  tL: string;
  tM: string;
  tS: string;
  amarillo: string;
  azul: string;
  rojo: string;
  gris: string;
  verde: string;
  negro: string;
  blanco: string;
  gr1000: number;
  gr1500: number;
  ltr: number;
  ltrVal: number;
  ltrPist: number;
  ltrPistRep: number;
  ltr5: number;
  ltr20: number;
  ltr38: number;
  kg44: number;
  kg22: number;
  kg1: number;
  kg4: number;
  kg21: number;
  precio: number;
  descuento: number;
  idProd: string;

  constructor(private prodSvc: ProductosService,
              private router: Router) { }

  ngOnInit(): void {
    this.prodSvc.cargarProductosAdmin()
                .subscribe(res => {
                  this.productosList = res;
                  // console.log(this.productosList);
                });
  }

  detalleProducto(producto: any){
    this.precio = producto.precio;
    this.nombre =  producto.nombre;
    this.categoria =  producto.categoria;
    this.descripcion =  producto.descripcion;
    this.imagen =  producto.imageProd;
    this.kiwi =  producto.kiwi;
    this.limon = producto.limon;
    this.sinAroma =  producto.sinAroma;
    this.floral = producto.floral;
    this.citronela = producto.citronela;
    this.lavanda = producto.lavanda;
    this.vinagre = producto.vinagre;
    this.frutosRojos = producto.frutosRojos;
    this.amarillo = producto.amarillo;
    this.tL = producto.tL;
    this.tM = producto.tM;
    this.tS = producto.tS;
    this.azul = producto.azul;
    this.rojo = producto.rojo;
    this.gris = producto.gris;
    this.verde = producto.verde;
    this.negro = producto.negro;
    this.blanco = producto.blanco;
    this.gr1000 = producto.gr1000;
    this.gr1500 = producto.gr1500;
    this.ltr =  producto.lt1;
    this.ltrVal =  producto.ltvalvula;
    this.ltrPist =  producto.ltrPist;
    this.ltrPistRep =  producto.ltPistolaRep;
    this.ltr5 =  producto.lt5;
    this.ltr20 =  producto.lt20;
    this.ltr38 =  producto.ltr38;
    this.kg44 =  producto.kg44;
    this.kg22 =  producto.kg22;
    this.kg1 =  producto.kg1;
    this.kg4 =  producto.kg4;
    this.kg21 =  producto.kg21;
    console.log(this.kg21);
  }

  edicionProducto(idProd: string){
    this.router.navigate([`editarProducto/${idProd}`]);
  }

  borrarProducto(producto: any){
    Swal.fire({
      title: 'Está seguro?',
      text: 'Se va a eliminar este producto del sistema!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.prodSvc.borrarProducto(producto.id);
        Swal.fire(
          'Eliminado!',
          'El producto fué borrado correctamente.',
          'success'
        );
      }
    });
  }

  precioPresentacion(price: number){
    this.precio = price;
  }

  productoSelected(id: string){
    this.idProd = id;
  }

  asignarDescuento(){
    console.log(this.idProd, this.descuento);    
    this.prodSvc.asignarDescuentoProducto(this.idProd, this.descuento);
  }

}
